import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_BY_PUBLISHERS = gql`
  query campaignOrderTransactionPublishers($id: ID!) {
    campaignOrderTransactionPublisherses(
      where: { campaignOrderTransactionReport: { analytics: { campaignOrder: { id: $id } } } }
    ) {
      media
      name
      impressions
      transactions
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_BY_PUBLISHERS;
